module.exports = __webpack_public_path__ + "img/income-and-expense-log_B09K25RW1K.42e549a0.jpg";